import React, {useEffect, useRef} from "react";
import {Button, Col, Row, Space, Typography} from "antd";
import ReactCanvasConfetti from 'react-canvas-confetti';
import {Trans, useTranslation} from "react-i18next";
import SheetModal from "../blocks/sheet-modal";
import Lottie from "react-lottie";

const {Text} = Typography;

const BingoLevelUp = ({showLevelUp, setShowLevelUp}) => {
    const confettiRef = useRef(null);
    const isFinalLevel = showLevelUp === 'final';
    const {t} = useTranslation();

    useEffect(() => {
        if (showLevelUp && isFinalLevel) {
            setTimeout(() => {
                startConfetti();
            }, 500);
        }
    }, [showLevelUp])

    const close = () => {
        setShowLevelUp(false)
    }

    const startConfetti = () => {
        if (confettiRef && confettiRef.current) {
            confettiRef.current.confetti();
        }
    }

    const defaultOptions = {
        loop: !isFinalLevel,
        autoplay: true,
        isStopped: false,
        animationData: require(isFinalLevel ? "../../../assets/videos/finished.json" : "../../../assets/videos/levelupstar.json"),
    }

    return (
        <SheetModal
            className="text-center"
            title={false}
            open={showLevelUp}
            close={close}
            footer={null}
        >
            <ReactCanvasConfetti
                style={{
                    width: "100%",
                    position: "absolute",
                    left: 0,
                    top: 0,
                    height: 500
                }}
                ref={confettiRef}
            />
            <h2>{!isFinalLevel ? t('bingo.level-up.title') : t('bingo.finished.title')}</h2>

            <Space direction="vertical" className="text-center">
                <Lottie options={defaultOptions}
                        style={{
                            transform: 'scale(0.7)', // zoom in
                            margin: '-100px 0', // adjust spacing as needed
                        }}
                />
                <br/>

                {isFinalLevel ? (
                    <div>
                        <Text className="fade-in-content" style={{animationDelay: "0.5s", display: "block"}}>
                            <Trans i18nKey='bingo.finished.desc' values={{level: showLevelUp}}/>
                        </Text>
                    </div>
                ) : (
                    <div>
                        <Text className="fade-in-content"
                              style={{animationDelay: "0.2s", display: "block"}}>{t('bingo.level-up.title-2')}</Text>
                        <Text className="fade-in-content" style={{animationDelay: "0.5s", display: "block"}}>
                            <Trans i18nKey='bingo.level-up.title-3' values={{level: showLevelUp}}/>
                        </Text>
                    </div>
                )}

                <br/>
            </Space>

            <Row gutter={[20, 20]} type="flex" justify="center">
                <Col span={12}>
                    <Button onClick={close} block size="large">{t('common.close')}</Button>
                </Col>

                {!isFinalLevel && (
                    <Col span={12}>
                        <Button block size="large" type="primary" onClick={close}>
                            <strong>{t('bingo.level-up.btn', {level: showLevelUp})}</strong></Button>
                    </Col>
                )}
            </Row>
        </SheetModal>
    )
}

export default BingoLevelUp;